import { app } from '../../../../../../app';
import { Controller } from './add-account-to-groups.controller';

app.component('companyUserDirectoriesManageAccountGroupsAppsAddToGroups', {
    bindings: {
        account: '<',
        companyId: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./add-account-to-groups.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/add-to-groups/add-account-to-groups.component.js